export default { "MAJOR": 1, "MINOR": 0, "PATCH": 0, "version": "1.0.0" }